import React from 'react';
import PdpRelatedItem from './pdpRelatedItem';
const PdpRelated = ({ data, addToShopifyCart }) => {
    var _a;
    let plantListMore = null;
    let content = null;
    const genusName = data.genus.name ? data.genus.name : data.genus;
    const sortedPlants = ((_a = data === null || data === void 0 ? void 0 : data.plant_list) === null || _a === void 0 ? void 0 : _a.length) > 0 && data.plant_list.sort((a, b) => (a.is_for_sale === b.is_for_sale ? 0 : a.is_for_sale ? -1 : 1));
    if (data && Object.keys(data).length > 0) {
        plantListMore = ((sortedPlants === null || sortedPlants === void 0 ? void 0 : sortedPlants.length) < data.plant_count) && (React.createElement("div", { className: "pdp_related_more" },
            React.createElement("a", { href: `${data.genus.url}`, className: "btn primary" },
                React.createElement("p", null, `+${data.plant_count - sortedPlants.length} more ${genusName}`))));
    }
    if ((sortedPlants === null || sortedPlants === void 0 ? void 0 : sortedPlants.length) > 0) {
        content = (React.createElement("div", { className: "pdp_related" },
            React.createElement("h2", null, `See other plant types of ${genusName} for your garden`),
            React.createElement("div", { className: "pdp_related__results" }, sortedPlants === null || sortedPlants === void 0 ? void 0 :
                sortedPlants.map((item) => (React.createElement(PdpRelatedItem, { data: item, key: item.django_pk, onAddToShopifyCart: addToShopifyCart }))),
                plantListMore)));
    }
    return content;
};
export default PdpRelated;
